import { toSentenceCase as sentenceCase } from './casing';

export function getStepperData(
  flowKey,
  formValues,
  activeStepName,
  options = {}
) {
  // TODO: Cater for other catergories. Receive the category as a parameter and use in the switch statement
  switch (flowKey) {
    case 'CarInsurance':
      return generateCarInsuranceStepper(formValues, activeStepName);
    case 'AdditionalDriver':
      return generateAdditionalDriverStepper(formValues, activeStepName);
    case 'ReturningUser':
      return generateVehicleReturningUserStepper(formValues, activeStepName);
    case 'FuneralInsurance':
      return generateFuneralInsuranceStepper(formValues, activeStepName);
    case 'LifeInsurance':
      return generateLifeInsuranceStepper(formValues, activeStepName);
    case 'GapCover':
      return generateGapCoverInsuranceStepper(formValues, activeStepName);
    case 'MedicalInsurance':
      return generateMedicalInsuranceStepper(formValues, activeStepName);
    case 'MotorWarranty':
      return generateMotorWarrantyStepper(formValues, activeStepName);
    case 'PersonalLoans':
      return generatePersonalLoansStepper(formValues, activeStepName);
    case 'DebtCounselling':
      return generateDebtCounsellingStepper(formValues, activeStepName);
    case 'DebtConsolidation':
      return generateDebtConsolidationStepper(formValues, activeStepName);
    case 'Scratch&DentCover':
      return generateScratchDentCoverStepper(formValues, activeStepName);
    case 'Tyre&RimCover':
      return generateTyreRimCoverCoverStepper(formValues, activeStepName);
    case 'VehicleTracking':
      return generateVehicleTrackingStepper(formValues, activeStepName);
    case 'ServicePlans':
      return generateServicePlansStepper(formValues, activeStepName);
    case 'MedicalAid':
      return generateMedicalAidStepper(formValues, activeStepName);
    case 'PetInsurance':
      return generatePetInsuranceStepper(formValues, activeStepName);
    case 'TravelInsurance':
      return generateTravelInsuranceStepper(formValues, activeStepName);
    case 'HomeContentsCover':
      return generateHomeContentsCoverStepper(formValues, activeStepName);
    case 'BuildingInsurance':
      return generateBuildingInsuranceStepper(formValues, activeStepName);
    case 'FibreInternet':
      return generateFibreInternetStepper(formValues, activeStepName);
    case 'BusinessInsurance':
      return generateBusinessInsuranceStepper(formValues, activeStepName);
    case 'BusinessLegalCover':
      return generateBusinessInsuranceStepper(formValues, activeStepName);
    case 'CommercialProperty':
      return generateBusinessInsuranceStepper(formValues, activeStepName);
    case 'ProfessionalLiability':
      return generateBusinessInsuranceStepper(formValues, activeStepName);
    case 'EmployeeBenefits':
      return generateEmployeeBenefitsStepper(formValues, activeStepName);
    case 'MotorcycleInsurance':
      return generateMotorcycleInsuranceStepper(formValues, activeStepName);
    case 'AdditionalMotorCycleDriver':
      return generateAdditionalMotorCycleDriverStepper(
        formValues,
        activeStepName
      );
    case 'CombinedQuotes':
      return generateCombinedQuotesStepper(formValues, activeStepName, options);

    // Add more flows as needed
    default:
      return generateDefaultStepper(formValues, activeStepName);
  }
}

function formatToDate({ year, month, day }) {
  if (!year || !month || !day) return null; // safeguard

  // pad month/day to always 2 digits
  const mm = month.toString().padStart(2, '0');
  const dd = day.toString().padStart(2, '0');

  return `${year}-${mm}-${dd}`;
}

function formatAdultCount(value) {
  if (value === undefined || value === null || value === '') return [];

  const count = Number(value);
  if (Number.isNaN(count)) return [];

  return `${count} ${count <= 1 ? 'Adult' : 'Adults'}`;
}

function formatChildCount(value) {
  if (value === undefined || value === null || value === '') return [];

  const count = Number(value);
  if (Number.isNaN(count)) return [];

  return `${count} ${count === 1 ? 'Child' : 'Children'}`;
}

function formatMedicalInsuranceChildCount(value) {
  if (value === undefined || value === null || value === '') return [];

  if (value === 'None') {
    return sentenceCase('No children');
  }

  const childCounts = {
    One: 'Child',
    Two: 'Children',
    Three: 'Children',
    Four: 'Children',
    Five: 'Children',
  };

  const childCountValues = {
    One: 1,
    Two: 2,
    Three: 3,
    Four: 4,
    Five: 5,
  };

  return childCounts[value]
    ? sentenceCase(`${childCountValues[value]} ${childCounts[value]}`)
    : sentenceCase(`${value} Children`);
}

function generateMotorWarrantyStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Vehicle',
      editIcon: {
        product: 'MotorWarranty',
        questionNumber: 1,
      },
      description: [
        {
          text: formValues?.carDetails
            ? `${formValues.carDetails.VehicleYear} ${formValues.carDetails.SearchDescription}`
            : '',
        },
        {
          text: formValues?.carWarranty
            ? formValues.carWarranty === 'Yes'
              ? sentenceCase('Active Warranty')
              : sentenceCase('Expired Warranty')
            : [],
        },
        {
          text: formValues?.carServicePlan
            ? formValues.carServicePlan === 'Yes'
              ? sentenceCase('Full Service History')
              : sentenceCase('No Service History')
            : [],
        },
        {
          text: formValues?.address,
        },
        {
          text: formValues?.carMileage ? formValues.carMileage + 'KM' : [],
        },
      ],
      activeStep: activeStepName === 'Vehicle',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'MotorWarranty',
        questionNumber: 6,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues.phone },
        { text: formValues.email },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateCombinedQuotesStepper(
  formValues,
  activeStepName,
  options = {}
) {
  const comboQueue = formValues?.comboJourney?.queue || [];
  const comboFlows = formValues?.comboFlows || {};
  const activeProduct = options?.activeProduct;
  const normalizedActiveStep = String(activeStepName || '')
    .trim()
    .toLowerCase();

  const aboutYouStepNames = new Set(['Policy Holder', 'About You']);
  const isYourQuotesStep = normalizedActiveStep === 'your quotes';
  const isConfigureStep =
    normalizedActiveStep === 'configure your quote' ||
    (activeProduct === 'CombinedQuotes' &&
      normalizedActiveStep !== 'about you' &&
      normalizedActiveStep !== 'your quotes');
  const isAboutYouStep =
    normalizedActiveStep === 'about you' ||
    aboutYouStepNames.has(activeStepName);
  const isAssetStep = !isConfigureStep && !isAboutYouStep && !isYourQuotesStep;

  const selectedQuotesDescription = comboQueue.map((item) => ({
    text: item.label,
  }));

  const aboutYouDescription = [
    { text: formValues?.fullName || '' },
    { text: formValues?.idNumber || '' },
    { text: formValues?.phone || '' },
    { text: formValues?.email || '' },
    {
      text: formValues?.birthday ? formatToDate(formValues.birthday) : '',
    },
  ].filter((item) => item.text);

  const carFlow = comboFlows.CarInsurance || {};
  const motorcycleFlow = comboFlows.MotorcycleInsurance || {};
  const buildingFlow = comboFlows.BuildingInsurance || {};
  const homeContentsFlow = comboFlows.HomeContentsCover || {};

  const assetDescription = [
    ...(comboQueue.some((item) => item.product === 'CarInsurance')
      ? [
          {
            text:
              carFlow?.carDetails?.SearchDescription ||
              carFlow?.yearOfManufacturer
                ? `Car: ${[
                    carFlow?.yearOfManufacturer,
                    carFlow?.carDetails?.SearchDescription,
                  ]
                    .filter(Boolean)
                    .join(' ')}`
                : '',
          },
          {
            text: carFlow?.nightAddress
              ? `Car night address: ${carFlow.nightAddress}`
              : '',
          },
          {
            text: carFlow?.vehicleUsage
              ? `Car use: ${sentenceCase(carFlow.vehicleUsage)}`
              : '',
          },
        ]
      : []),
    ...(comboQueue.some((item) => item.product === 'MotorcycleInsurance')
      ? [
          {
            text:
              motorcycleFlow?.motorCycleDetails?.MotorcycleDescription ||
              motorcycleFlow?.yearOfMotorCycleManufacturer
                ? `Motorcycle: ${[
                    motorcycleFlow?.yearOfMotorCycleManufacturer,
                    motorcycleFlow?.motorCycleDetails?.MotorcycleDescription,
                  ]
                    .filter(Boolean)
                    .join(' ')}`
                : '',
          },
          {
            text: motorcycleFlow?.bikeValue
              ? `Motorcycle value: R${motorcycleFlow.bikeValue}`
              : '',
          },
          {
            text: motorcycleFlow?.nightAddress
              ? `Motorcycle night address: ${motorcycleFlow.nightAddress}`
              : '',
          },
        ]
      : []),
    ...(comboQueue.some((item) => item.product === 'BuildingInsurance')
      ? [
          {
            text: buildingFlow?.homeValue
              ? `Building cover: R${buildingFlow.homeValue}`
              : '',
          },
          {
            text: buildingFlow?.buildingAddress
              ? `Building address: ${buildingFlow.buildingAddress}`
              : '',
          },
          {
            text: buildingFlow?.numberOfGeysers
              ? sentenceCase(`Geysers: ${buildingFlow.numberOfGeysers}`)
              : '',
          },
        ]
      : []),
    ...(comboQueue.some((item) => item.product === 'HomeContentsCover')
      ? [
          {
            text: homeContentsFlow?.homeContentValue
              ? `Home contents cover: R${homeContentsFlow.homeContentValue}`
              : '',
          },
          {
            text: homeContentsFlow?.homeAddress
              ? homeContentsFlow.homeAddress
              : '',
          },
          {
            text: Array.isArray(homeContentsFlow?.extraSecurityFeatures)
              ? sentenceCase(homeContentsFlow.extraSecurityFeatures.join(', '))
              : '',
          },
        ]
      : []),
  ].filter((item) => item.text);

  const firstQueuedProduct = comboQueue[0]?.product;

  const comboEditQuestionConfig = {
    CarInsurance: {
      configure: {
        product: 'CombinedQuotes',
        questionNumber: 1,
        category: 'Bundle',
      },
      assets: {
        product: 'CarInsurance',
        questionNumber: 4,
        category: 'Vehicle',
      },
      aboutYou: {
        product: 'CombinedQuotes',
        questionNumber: 2,
        category: 'Bundle',
        forceComboQuestionReview: true,
      },
    },
    MotorcycleInsurance: {
      configure: {
        product: 'CombinedQuotes',
        questionNumber: 1,
        category: 'Bundle',
      },
      assets: {
        product: 'MotorcycleInsurance',
        questionNumber: 3,
        category: 'Vehicle',
      },
      aboutYou: {
        product: 'CombinedQuotes',
        questionNumber: 2,
        category: 'Bundle',
        forceComboQuestionReview: true,
      },
    },
    BuildingInsurance: {
      configure: {
        product: 'CombinedQuotes',
        questionNumber: 1,
        category: 'Bundle',
      },
      assets: {
        product: 'BuildingInsurance',
        questionNumber: 1,
        category: 'Home',
      },
      aboutYou: {
        product: 'CombinedQuotes',
        questionNumber: 2,
        category: 'Bundle',
        forceComboQuestionReview: true,
      },
    },
    HomeContentsCover: {
      configure: {
        product: 'CombinedQuotes',
        questionNumber: 1,
        category: 'Bundle',
      },
      assets: {
        product: 'HomeContentsCover',
        questionNumber: 1,
        category: 'Home',
      },
      aboutYou: {
        product: 'CombinedQuotes',
        questionNumber: 2,
        category: 'Bundle',
        forceComboQuestionReview: true,
      },
    },
  };

  const editConfig =
    comboEditQuestionConfig[firstQueuedProduct] ||
    comboEditQuestionConfig.CarInsurance;

  return {
    title: 'Your Info',
    steps: [
      {
        step: 0,
        label: 'Configure your quote',
        editIcon: editConfig.configure,
        description: selectedQuotesDescription,
        activeStep: isConfigureStep,
      },
      {
        step: 1,
        label: 'About you',
        editIcon: editConfig.aboutYou,
        description: aboutYouDescription,
        activeStep: isAboutYouStep,
      },
      {
        step: 2,
        label: 'About your Assets',
        editIcon: editConfig.assets,
        description: assetDescription,
        activeStep: isAssetStep,
      },
      {
        step: 3,
        label: 'Your Quotes',
        description: [],
        activeStep: isYourQuotesStep,
      },
    ],
  };
}

function generateCarInsuranceStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Policy Holder',
      editIcon: {
        product: 'CarInsurance',
        questionNumber: 1,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.idNumber },
        {
          text: formValues.idNumber
            ? `${parseInt(formValues.idNumber.substring(0, 2), 10)}/${parseInt(
                formValues.idNumber.substring(2, 4),
                10
              )}/${parseInt(formValues.idNumber.substring(4, 6), 10)}`
            : '',
        },
        { text: sentenceCase(formValues.maritalStatus) },
      ],
      activeStep: activeStepName === 'Policy Holder',
    },
    {
      step: 1,
      label: 'Vehicle',
      editIcon: {
        product: 'CarInsurance',
        questionNumber: 6,
      },
      description: [
        { text: formValues.yearOfManufacturer },
        { text: formValues.carDetails?.SearchDescription },
        {
          text: formValues.nightAddress
            ? `Night address: ${formValues.nightAddress}`
            : '',
        },
        { text: sentenceCase(formValues.NightSecurity) },
        {
          text: formValues.dayAddress
            ? `Day address: ${formValues.dayAddress}`
            : '',
        },
        { text: sentenceCase(formValues.daySecurity) },
      ],
      activeStep: activeStepName === 'Vehicle',
    },
    {
      step: 2,
      label: 'Driver',
      editIcon: {
        product: 'CarInsurance',
        questionNumber: 9,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.idNumber },
        { text: sentenceCase(formValues.maritalStatus) },
        { text: sentenceCase(formValues.mainDriverLicense) },
        {
          text: formValues.LicenseFirstIssue
            ? `Issued: ${formValues.LicenseFirstIssue.year}/${formValues.LicenseFirstIssue.month}`
            : '',
        },
        {
          text: formValues.uninterruptedCarInsurance
            ? `Years insured: ${formValues.uninterruptedCarInsurance}`
            : '',
        },
        {
          text: formValues.LastClaimYears
            ? `Last claimed: ${formValues.LastClaimYears}`
            : '',
        },
      ],
      activeStep: activeStepName === 'Driver',
    },
    {
      step: 3,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateAdditionalDriverStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Policy Holder',
      editIcon: {
        product: 'CarInsurance',
        questionNumber: 1,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.idNumber },
        {
          text: formValues.idNumber
            ? `${parseInt(formValues.idNumber.substring(0, 2), 10)}/${parseInt(
                formValues.idNumber.substring(2, 4),
                10
              )}/${parseInt(formValues.idNumber.substring(4, 6), 10)}`
            : '',
        },
        { text: sentenceCase(formValues.maritalStatus) },
      ],
      activeStep: activeStepName === 'Policy Holder',
    },
    {
      step: 1,
      label: 'Vehicle',
      editIcon: {
        product: 'CarInsurance',
        questionNumber: 6,
      },
      description: [
        { text: formValues.yearOfManufacturer },
        { text: formValues.carDetails?.SearchDescription },
        {
          text: formValues.nightAddress
            ? `Night address: ${formValues.nightAddress}`
            : '',
        },
        { text: sentenceCase(formValues.nightSecurity) },
        {
          text: formValues.dayAddress
            ? `Day address: ${formValues.dayAddress}`
            : '',
        },
        { text: sentenceCase(formValues.daySecurity) },
      ],
      activeStep: activeStepName === 'Vehicle',
    },
    {
      step: 2,
      label: 'Driver',
      editIcon: {
        product: 'CarInsurance',
        questionNumber: 9,
      },
      description: [
        { text: formValues.additionalDriverFullName },
        { text: sentenceCase(formValues.additionalDriverMaritalStatus) },
        { text: sentenceCase(formValues.additionalDriverDriverLicense) },
        {
          text: formValues.additionalDriverLicenseFirstIssue
            ? `Issued: ${formValues.additionalDriverLicenseFirstIssue.year}/${formValues.additionalDriverLicenseFirstIssue.month}`
            : '',
        },
        {
          text: formValues.additionalDriverUninterruptedCarInsurance
            ? `Years insured: ${formValues.additionalDriverUninterruptedCarInsurance}`
            : '',
        },
        {
          text: formValues.additionalDriverLastClaimYears
            ? `Last claimed: ${formValues.additionalDriverLastClaimYears}`
            : '',
        },
      ],
      activeStep: activeStepName === 'Driver',
    },
    {
      step: 3,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateVehicleReturningUserStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Policy Holder',
      editIcon: {
        product: 'ReturningUser',
        questionNumber: 1,
      },
      description: [],
      activeStep: activeStepName === 'Policy Holder',
    },
    {
      step: 1,
      label: 'Vehicle',
      editIcon: {
        product: 'ReturningUser',
        questionNumber: 2,
      },
      description: [],
      activeStep: activeStepName === 'Vehicle',
    },
    {
      step: 2,
      label: 'Driver',
      editIcon: {
        product: 'ReturningUser',
        questionNumber: 3,
      },
      description: [],
      activeStep: activeStepName === 'Driver',
    },
    {
      step: 3,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];
  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateDefaultStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Policy Holder',
      editIcon: {
        product: 'CarInsurance',
        questionNumber: 1,
      },
      description: [],
      activeStep: activeStepName === 'Policy Holder',
    },
    {
      step: 1,
      label: 'Vehicle',
      editIcon: {
        product: 'CarInsurance',
        questionNumber: 4,
      },
      description: [],
      activeStep: activeStepName === 'Vehicle',
    },
    {
      step: 2,
      label: 'Driver',
      editIcon: {
        product: 'CarInsurance',
        questionNumber: 8,
      },
      description: [],
      activeStep: activeStepName === 'Driver',
    },
    {
      step: 3,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];
  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateFuneralInsuranceStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Your Cover Needs',
      editIcon: {
        product: 'FuneralInsurance',
        questionNumber: 1,
      },
      description: [{ text: formValues.funeralCoverAmount }],
      activeStep: activeStepName === 'Your Cover Needs',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'FuneralInsurance',
        questionNumber: 2,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues.phone },
        { text: formValues.email },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
        { text: formValues.salaryRange },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      editIcon: {
        product: 'FuneralInsurance',
        questionNumber: 7,
      },
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];
  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateLifeInsuranceStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Your Cover Needs',
      editIcon: {
        product: 'LifeInsurance',
        questionNumber: 1,
      },
      description: [{ text: formValues.lifeCoverValue }],
      activeStep: activeStepName === 'Your Cover Needs',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'LifeInsurance',
        questionNumber: 2,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues.phone },
        { text: formValues.email },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
        {
          text: formValues?.smoker
            ? formValues.smoker === "Yes, I'm a smoker"
              ? sentenceCase('Smoker')
              : sentenceCase('Non Smoker')
            : [],
        },
        { text: sentenceCase(formValues.educationLevel) },
        { text: formValues.grossMonthlyIncome },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      editIcon: {
        product: 'LifeInsurance',
        questionNumber: 9,
      },
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];
  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateGapCoverInsuranceStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Your Cover Needs',
      editIcon: {
        product: 'GapCover',
        questionNumber: 1,
      },
      description: [
        {
          text: formValues?.gapCover
            ? formValues.gapCover === 'Yes'
              ? sentenceCase('Medical Aid Confirmation')
              : sentenceCase('No Medical Aid Confirmation')
            : [],
        },
        { text: sentenceCase(formValues.gapCoverType) },
        { text: sentenceCase(formValues.coverFamily) },
      ],
      activeStep: activeStepName === 'Your Cover Needs',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'GapCover',
        questionNumber: 4,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues.phone },
        { text: formValues.email },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      editIcon: {
        product: 'GapCover',
        questionNumber: 4,
      },
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];
  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateMedicalInsuranceStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Your Family Size',
      editIcon: {
        product: 'MedicalInsurance',
        questionNumber: 1,
      },
      description: [
        {
          text: formValues?.medicalInsuranceSpouse
            ? formValues.medicalInsuranceSpouse === 'Just Me'
              ? sentenceCase('1 Adult')
              : sentenceCase('2 Adults')
            : [],
        },
        {
          text: formatMedicalInsuranceChildCount(
            formValues?.medicalInsuranceNumberOfKids
          ),
        },
      ],
      activeStep: activeStepName === 'Your Family Size',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'MedicalInsurance',
        questionNumber: 3,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues.phone },
        { text: formValues.email },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      editIcon: {
        product: 'MedicalInsurance',
        questionNumber: 7,
      },
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];
  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generatePersonalLoansStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'About You',
      editIcon: {
        product: 'PersonalLoans',
        questionNumber: 1,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.phone },
        { text: formValues.email },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Offers',
      editIcon: {
        product: 'PersonalLoans',
        questionNumber: 1,
      },
      description: [],
      activeStep: activeStepName === 'Your Offers',
    },
  ];
  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateDebtConsolidationStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'About You',
      editIcon: {
        product: 'DebtConsolidation',
        questionNumber: 1,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.phone },
        { text: formValues.email },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Offers',
      editIcon: {
        product: 'DebtConsolidation',
        questionNumber: 1,
      },
      description: [],
      activeStep: activeStepName === 'Your Offers',
    },
  ];
  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateDebtCounsellingStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'About You',
      editIcon: {
        product: 'DebtCounselling',
        questionNumber: 1,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.phone },
        { text: formValues.email },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Offers',
      editIcon: {
        product: 'DebtCounselling',
        questionNumber: 1,
      },
      description: [],
      activeStep: activeStepName === 'Your Offers',
    },
  ];
  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateScratchDentCoverStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Vehicle',
      editIcon: {
        product: 'Scratch&DentCover',
        questionNumber: 1,
      },
      description: [
        {
          text: formValues?.carDetails
            ? `${formValues.carDetails.VehicleYear} ${formValues.carDetails.SearchDescription}`
            : '',
        },
      ],
      activeStep: activeStepName === 'Vehicle',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'Scratch&DentCover',
        questionNumber: 2,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues.phone },
        { text: formValues.email },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateTyreRimCoverCoverStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'About Your Vehicle',
      editIcon: {
        product: 'Tyre&RimCover',
        questionNumber: 1,
      },
      description: [
        {
          text: formValues?.carDetails
            ? `${formValues.carDetails.VehicleYear} ${formValues.carDetails.SearchDescription}`
            : '',
        },
        { text: sentenceCase(formValues.rimType) },
        { text: formValues.address },
      ],
      activeStep: activeStepName === 'About Your Vehicle',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'Tyre&RimCover',
        questionNumber: 4,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues.phone },
        { text: formValues.email },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateVehicleTrackingStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Insurance Confirmation',
      editIcon: {
        product: 'VehicleTracking',
        questionNumber: 1,
      },
      description: [
        {
          text: formValues?.carInsurance
            ? formValues.carInsurance === 'Yes'
              ? sentenceCase('Confirmed')
              : sentenceCase('Not Insured')
            : [],
        },
      ],
      activeStep: activeStepName === 'Insurance Confirmation',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'VehicleTracking',
        questionNumber: 2,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues.phone },
        { text: formValues.email },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateMedicalAidStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Your Medical Aid Needs',
      editIcon: {
        product: 'MedicalAid',
        questionNumber: 1,
      },
      description: [
        {
          text: formatAdultCount(formValues?.adultsCoveredMedicalAid),
        },
        {
          text: formatChildCount(formValues?.childrenCoveredMedicalAid),
        },
        // ...(formValues?.whyMedicalAid || []).map((reason) => ({
        //   text: reason,
        // })),
        { text: sentenceCase(formValues.hospitalChoice) },
        { text: sentenceCase(formValues.treatmentsCovered) },
        { text: sentenceCase(formValues.dayTreatmentsCovered) },
        // ...(formValues?.benefits || []).map((reason) => ({
        //   text: reason,
        // })),
      ],
      activeStep: activeStepName === 'Your Medical Aid Needs',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'MedicalAid',
        questionNumber: 7,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues.phone },
        { text: formValues.email },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateServicePlansStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Vehicle',
      editIcon: {
        product: 'ServicePlans',
        questionNumber: 1,
      },
      description: [
        {
          text: formValues?.carDetails
            ? `${formValues.carDetails.VehicleYear} ${formValues.carDetails.SearchDescription}`
            : '',
        },
      ],
      activeStep: activeStepName === 'Vehicle',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'ServicePlans',
        questionNumber: 2,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues.phone },
        { text: formValues.email },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generatePetInsuranceStepper(formValues, activeStepName) {
  const numberOfPets = Number(formValues?.numberOfPets) || 0;
  const pets = Array.isArray(formValues?.pets) ? formValues.pets : [];
  const petCountLabel = numberOfPets === 1 ? '1 Pet' : `${numberOfPets} Pets`;

  const stepData = [
    {
      step: 0,
      label: 'Your Pets',
      editIcon: {
        product: 'PetInsurance',
        questionNumber: 1,
      },
      description: [
        { text: numberOfPets ? petCountLabel : '' },
        ...pets.slice(0, numberOfPets).map((pet) => ({
          text: pet.gender ? `${pet.name} (${pet.gender})` : '',
        })),
      ],
      activeStep: activeStepName === 'Your Pets',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'PetInsurance',
        questionNumber: 3,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues.phone },
        { text: formValues.email },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : '' },
      ],
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateTravelInsuranceStepper(formValues, activeStepName) {
  const travelCountries = Array.isArray(formValues?.travelCountries)
    ? formValues.travelCountries
    : [];

  const travelCoverDates = Array.isArray(formValues?.travelCoverDates)
    ? formValues.travelCoverDates
    : [];

  const fmtISODate = (iso) =>
    typeof iso === 'string' && iso.length >= 10 ? iso.slice(0, 10) : '';

  const countriesLine =
    travelCountries.length > 0
      ? `Traveling to ${travelCountries.join(',')}`
      : '';

  const datesLine =
    travelCoverDates.length === 2
      ? `${fmtISODate(travelCoverDates[0])} to ${fmtISODate(
          travelCoverDates[1]
        )}`
      : '';

  const travellersCount = formValues?.numberOfPeopleTraveling;
  const travellersLine =
    travellersCount != null && `${travellersCount} Travellers`;

  const stepData = [
    {
      step: 0,
      label: 'Your Travel Information',
      editIcon: {
        product: 'TravelInsurance',
        questionNumber: 1,
      },
      description: [
        { text: countriesLine },
        { text: datesLine },
        { text: travellersLine },
      ].filter((item) => item.text),
      activeStep: activeStepName === 'Your Travel Information',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'TravelInsurance',
        questionNumber: 4,
      },
      description: [
        {
          text:
            formValues?.firstName && formValues?.surname
              ? `${formValues.firstName} ${formValues.surname}`
              : '',
        },
        { text: formValues?.phone || '' },
        { text: formValues?.email || '' },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : '' },
      ].filter((item) => item.text),
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateBuildingInsuranceStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'About Your Building',
      editIcon: {
        product: 'BuildingInsurance',
        questionNumber: 1,
      },
      description: [
        {
          text: formValues?.homeValue
            ? sentenceCase('R' + formValues?.homeValue + ' Building Cover')
            : '',
        },
        {
          text: formValues?.buildingAddress ? formValues.buildingAddress : '',
        },
        {
          text: formValues?.numberOfGeysers
            ? formValues?.numberOfGeysers === '1'
              ? `${formValues?.numberOfGeysers} Geyser`
              : `${formValues?.numberOfGeysers} Geysers`
            : '',
        },
      ].filter((item) => item.text),
      activeStep: activeStepName === 'About Your Building',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'BuildingInsurance',
        questionNumber: 4,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.idNumber },
        { text: formValues?.phone || '' },
        { text: formValues?.email || '' },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
      ].filter((item) => item.text),
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateHomeContentsCoverStepper(formValues, activeStepName) {
  const extraSecurityFeatures = Array.isArray(formValues?.extraSecurityFeatures)
    ? formValues.extraSecurityFeatures
    : [];

  const stepData = [
    {
      step: 0,
      label: 'About Your Home',
      editIcon: {
        product: 'HomeContentsCover',
        questionNumber: 1,
      },
      description: [
        {
          text: formValues?.homeContentValue
            ? sentenceCase(
                'R' + formValues?.homeContentValue + ' Home Contents'
              )
            : '',
        },
        {
          text: formValues?.moveIntoHome
            ? 'Moved in : ' +
              formValues.moveIntoHome.year +
              '-' +
              formValues.moveIntoHome.month
            : '',
        },
        {
          text: formValues?.occupiedDuringDay
            ? formValues.occupiedDuringDay === 'Yes'
              ? sentenceCase('Occupied during day')
              : sentenceCase('Not occupied during day')
            : [],
        },
        {
          text: formValues?.homeBordered
            ? formValues.homeBordered === 'Yes'
              ? sentenceCase('Neighbors all round')
              : sentenceCase('No neighbors')
            : [],
        },
        {
          text:
            formValues?.breakInHappen && formValues?.homeBreakIns === 'Yes'
              ? 'Had break-in: ' +
                formValues.breakInHappen.year +
                '-' +
                formValues.breakInHappen.month
              : '',
        },
        ...extraSecurityFeatures.map((security) => ({
          text: sentenceCase(security),
        })),
        { text: formValues.homeAddress },
      ].filter((item) => item.text),
      activeStep: activeStepName === 'About Your Home',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'HomeContentsCover',
        questionNumber: 9,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.idNumber },
        { text: formValues?.phone || '' },
        { text: formValues?.email || '' },
        { text: formValues?.birthday ? formatToDate(formValues.birthday) : [] },
      ].filter((item) => item.text),
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateFibreInternetStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Your Fibre Information',
      editIcon: {
        product: 'FibreInternet',
        questionNumber: 1,
      },
      description: [
        {
          text: formValues?.fibreAddress ? formValues?.fibreAddress : '',
        },
      ].filter((item) => item.text),
      activeStep: activeStepName === 'Your Fibre Information',
    },
    {
      step: 1,
      label: 'About You',
      editIcon: {
        product: 'FibreInternet',
        questionNumber: 8,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.idNumber },
        { text: formValues?.phone || '' },
        { text: formValues?.email || '' },
      ].filter((item) => item.text),
      activeStep: activeStepName === 'About You',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateBusinessInsuranceStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'About Your Business',
      editIcon: {
        product: 'BusinessInsurance',
        questionNumber: 1,
      },
      description: [
        {
          text: formValues?.businessName ? formValues?.businessName : '',
        },
        { text: formValues.industryCategory?.label },
        {
          text: formValues?.totalAssest10Million
            ? formValues.totalAssest10Million === 'Yes'
              ? sentenceCase('+R10m in assets')
              : sentenceCase('< R10m in assets')
            : [],
        },
        {
          text: formValues?.moreThan10Vehicles
            ? formValues.moreThan10Vehicles === 'Yes'
              ? sentenceCase('+10 Cars')
              : sentenceCase('< 10 Cars')
            : [],
        },
        {
          text: formValues?.professionalIndemnity
            ? formValues.professionalIndemnity === 'Yes'
              ? sentenceCase('Need indemnity insurance')
              : sentenceCase("Don't need indemnity insurance")
            : [],
        },
        {
          text: formValues?.publicLiablity
            ? formValues.publicLiablity === 'Yes'
              ? sentenceCase('Need liability coverage')
              : sentenceCase("Don't need liability coverage")
            : [],
        },
      ].filter((item) => item.text),
      activeStep: activeStepName === 'About Your Business',
    },
    {
      step: 1,
      label: 'Contact Person',
      editIcon: {
        product: 'BusinessInsurance',
        questionNumber: 7,
      },
      description: [
        {
          text:
            formValues?.businessPersonFirstName &&
            formValues?.businessPersonSurname
              ? `${formValues.businessPersonFirstName} ${formValues.businessPersonSurname}`
              : '',
        },
        { text: formValues?.businessPersonPhone || '' },
        { text: formValues?.businessPersonEmail || '' },
      ].filter((item) => item.text),
      activeStep: activeStepName === 'Contact Person',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateEmployeeBenefitsStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'About Your Business',
      editIcon: {
        product: 'EmployeeBenefits',
        questionNumber: 1,
      },
      description: [
        ...(formValues?.whyBusinessMedicalAid || []).map((reason) => ({
          text: sentenceCase(reason),
        })),
        { text: formValues.medicalInsuranceNumberOfEmployees },
        {
          text: formValues?.businessName ? formValues?.businessName : '',
        },
      ],

      activeStep: activeStepName === 'About Your Business',
    },
    {
      step: 1,
      label: 'Contact Person',
      editIcon: {
        product: 'EmployeeBenefits',
        questionNumber: 7,
      },
      description: [
        {
          text:
            formValues?.businessPersonFirstName &&
            formValues?.businessPersonSurname
              ? `${formValues.businessPersonFirstName} ${formValues.businessPersonSurname}`
              : '',
        },
        { text: formValues?.businessPersonPhone || '' },
        { text: formValues?.businessPersonEmail || '' },
      ],
      activeStep: activeStepName === 'Contact Person',
    },
    {
      step: 2,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateMotorcycleInsuranceStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Policy Holder',
      editIcon: {
        product: 'MotorcycleInsurance',
        questionNumber: 1,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.idNumber },
      ],
      activeStep: activeStepName === 'Policy Holder',
    },
    {
      step: 1,
      label: 'About Your Motorcycle',
      editIcon: {
        product: 'MotorcycleInsurance',
        questionNumber: 3,
      },
      description: [
        { text: formValues.yearOfMotorCycleManufacturer },
        { text: formValues.motorCycleDetails?.MotorcycleDescription },
        {
          text: formValues.bikeValue ? 'R' + formValues.bikeValue : '',
        },
        {
          text: formValues.nightAddress
            ? `Night address: ${formValues.nightAddress}`
            : '',
        },
        { text: sentenceCase(formValues.nightSecurity) },
      ],
      activeStep: activeStepName === 'About Your Motorcycle',
    },
    {
      step: 2,
      label: 'Driver',
      editIcon: {
        product: 'MotorcycleInsurance',
        questionNumber: 6,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.idNumber },
        { text: sentenceCase(formValues.mainDriverLicense) },
        {
          text: formValues.licenseFirstIssue
            ? sentenceCase(
                `Issued: ${formValues.licenseFirstIssue.year}/${formValues.licenseFirstIssue.month}`
              )
            : '',
        },
        { text: sentenceCase(formValues.maritalStatus) },
        {
          text: formValues.uninterruptedBikeInsurance
            ? `Claim free: ${formValues.uninterruptedBikeInsurance} years`
            : '',
        },
      ],
      activeStep: activeStepName === 'Driver',
    },
    {
      step: 3,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}

function generateAdditionalMotorCycleDriverStepper(formValues, activeStepName) {
  const stepData = [
    {
      step: 0,
      label: 'Policy Holder',
      editIcon: {
        product: 'MotorcycleInsurance',
        questionNumber: 1,
      },
      description: [
        { text: formValues.fullName },
        { text: formValues.idNumber },
      ],
      activeStep: activeStepName === 'Policy Holder',
    },
    {
      step: 1,
      label: 'About Your Motorcycle',
      editIcon: {
        product: 'MotorcycleInsurance',
        questionNumber: 3,
      },
      description: [
        { text: formValues.yearOfMotorCycleManufacturer },
        { text: formValues.motorCycleDetails?.MotorcycleDescription },
        {
          text: formValues.bikeValue ? 'R' + formValues.bikeValue : '',
        },
        {
          text: formValues.nightAddress
            ? `Night address: ${formValues.nightAddress}`
            : '',
        },
        { text: sentenceCase(formValues.nightSecurity) },
      ],
      activeStep: activeStepName === 'About Your Motorcycle',
    },
    {
      step: 2,
      label: 'Driver',
      editIcon: {
        product: 'MotorcycleInsurance',
        questionNumber: 6,
      },
      description: [
        { text: formValues.additionalDriverFullName },
        {
          text: formValues?.additionalDriverBirthday
            ? formatToDate(formValues.additionalDriverBirthday)
            : '',
        },
        { text: sentenceCase(formValues.additionalDriverMaritalStatus) },
        { text: sentenceCase(formValues.additionalDriverDriverLicense) },
        {
          text: formValues.additionalDriverLicenseFirstIssue
            ? `Issued: ${formValues.additionalDriverLicenseFirstIssue.year}/${formValues.additionalDriverLicenseFirstIssue.month}`
            : '',
        },
        {
          text: formValues.additionalDriverUninterruptedBikeInsurance
            ? `Claim free: ${formValues.additionalDriverUninterruptedBikeInsurance} years`
            : '',
        },
      ],
      activeStep: activeStepName === 'Driver',
    },
    {
      step: 3,
      label: 'Your Quotes',
      description: [],
      activeStep: activeStepName === 'Your Quotes',
    },
  ];

  return {
    title: 'Your Info',
    steps: stepData,
  };
}
